import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'

import useLocationTimezone from 'shared/hooks/useLocationTimezone'

import { getScanticketLocation } from '../actions'

import {
    scanticketLocationPendingSelector,
    scanticketLocationSelector,
    scanticketTicketSelector,
} from 'scanticket/selectors'
import { SCAN_TICKET_STEP_SCAN_QR, SCAN_TICKET_STEP_TICKET_INFO } from 'scanticket/constants'

import TicketReview from './TicketReview'
import ScanQr from './ScanQr'
import CircleLoader from 'shared/components/CircleLoader'
import ErrorMessage from 'shared/components/ErrorMessage'
import { sendAmplitudeEvent, useSendGTAGEvent } from 'analytics/utils'
import { ANALYTICS_FLOW_TYPE_SCAN_TICKET } from 'analytics/constants'
import styles from './styles.module.scss'

const ScanTicket = ({ history }) => {
    const dispatch = useDispatch()
    const location = useSelector(scanticketLocationSelector)
    const pending = useSelector(scanticketLocationPendingSelector)
    const { grsId } = useParams()
    const [currentStep, setCurrentStep] = useState(SCAN_TICKET_STEP_SCAN_QR)
    const ticket = useSelector(scanticketTicketSelector)
    const sendGTAGEvent = useSendGTAGEvent()

    useLocationTimezone(location?.timeZoneIdentifier)

    useEffect(() => {
        dispatch(getScanticketLocation(grsId))
    }, [])

    useEffect(() => {
        if (location) {
            sendAmplitudeEvent('Begin Checkout', {
                'Flow Type': ANALYTICS_FLOW_TYPE_SCAN_TICKET,
                'Location Name': location.name,
            })
            sendGTAGEvent('begin_checkout', {
                flow_type: ANALYTICS_FLOW_TYPE_SCAN_TICKET,
                location_name: location.name,
            })
        }
    }, [location])

    useEffect(() => {
        if (ticket) setCurrentStep(SCAN_TICKET_STEP_TICKET_INFO)
    }, [ticket])

    const onTicketPurchaseSuccess = response => {
        history.push(`/scanticket/confirmation/${response.freeexituntil}`)
    }

    const getCurrentStep = () => {
        switch (currentStep) {
            case SCAN_TICKET_STEP_SCAN_QR:
                return <ScanQr locationName={location?.name} />
            case SCAN_TICKET_STEP_TICKET_INFO:
                return (
                    <TicketReview
                        history={history}
                        ticket={ticket}
                        locationName={location?.name}
                        successCallback={onTicketPurchaseSuccess}
                    />
                )
            default:
                return <ScanQr />
        }
    }

    return (
        <div className="d-flex flex-column justify-content-center align-items-center">
            {location && <div className={styles.contentContainer}>{getCurrentStep()}</div>}
            {!location && pending === true && <CircleLoader className="mt-6 mb-6" />}
            {pending instanceof Error && <ErrorMessage className="mt-6 mb-6" messages={[pending.message]} />}
        </div>
    )
}

export default ScanTicket
